import { render } from "./ExampleOAuth2AuthorizeCallback.vue?vue&type=template&id=1b8b2abe&scoped=true&bindings={\"code\":\"data\",\"state\":\"data\",\"error\":\"data\",\"error_status\":\"data\",\"error_description\":\"data\",\"error_at\":\"data\",\"error_trace_id\":\"data\",\"error_uri\":\"data\",\"error_on\":\"data\"}"
import script from "./ExampleOAuth2AuthorizeCallback.vue?vue&type=script&lang=js"
export * from "./ExampleOAuth2AuthorizeCallback.vue?vue&type=script&lang=js"

import "./ExampleOAuth2AuthorizeCallback.vue?vue&type=style&index=0&id=1b8b2abe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b8b2abe"

export default script